// 导出端上提供的所有api列表：
/*
 * {
 *   actionName：api名 | string
 *   version：适用的app版本号
 *   category H5调用app ---- registerHandler app点用H5
 *   desc： 描述
 *   type：功能分类
 *  }
 */

import util from './util';
let dida_callHandler = {
  getLocation: '8.1.0',
  getNetworkStatus:'8.1.0',
  getCityInfo:'',
  getDeviceId: '8.3.5',
  getSMDeviceId: '8.10.0',
  saveImage: '8.7.0',
  faceDetect: '8.10.25',
  getOtherDeviceInfo:'8.14.0',
  doQRScan:'8.15.0',
  locoMediaSelector: '',
  setVibrate:'',
  getClipboardCache:'',
  startNetworkSetting:'8.1.0',
  sendMsg:'8.1.5',
  goToKF:'8.21.0',
  jumpToMiniPro:'8.10.50',
  uploadTripEmail:'8.10.50',
  getTripEmail:'8.10.50',
  callNavigationSelectView:'8.15.0',
  startAuthoritySetting:'8.19.0',
  goToVideoPlayer:'8.32.0',
  couponPaySuccess: '8.36.0',
  webviewGoBack:'8.4.5',
  webviewClose:'8.4.5',
  extendBtn:'',
  loadingbar:'',
  statusBarShare:'8.3.5',
  shareOnTheWebviewPage:'8.3.5',
  clickControlToShare:'8.3.5',
  shareWxMinipg:'8.9.0',
  shareWxImages:'8.5.0',
  getUserInfo:'8.9.0',
  invokePay:'8.10.90',
  invokePayCallBack:'8.10.90',
  getUserRole:'',
  reload:'',
  pageFinish:'',
  setCloseWebview:'9.4.0',
  jdPayHandle: '8.10.20',
  webviewRefreshApp: '9.11.0',
  getDeviceAlipay: '9.15.0',
  hideLoadingDialog: '9.15.0',
  webviewPostMessageApp: '9.19.0',
  goToChooseLocation: '9.53.0',
  getUDID: '9.53.0',
  commonNotificationCallBack: '9.57.0',
  nameVerify: '9.58.1'
}
let dida_registerHandler = {
  refreshLocation: '8.1.0',
  faceDetectCallBack: '8.10.25',
  shareCallBack:'8.3.5',
  closeWebviewCallBack:'8.37.0',
  chooseLocationCallback: '9.53.0',
  nameVerifyCallBack: '9.58.1'
}


let didaTaxi_callHandler = {
  playVideo:'3.5.10',
  getDarkMode:'3.5.10',
  getDarkMode:'3.5.35',
  getLocation:'3.5.35',
  callPhoneWithHolly: '4.10.0',
}

export default {
  callHandler: util.appInfo.isDidaPinche ? dida_callHandler : didaTaxi_callHandler,
  registerHandler: util.appInfo.isDidaPinche ? dida_registerHandler : {}
}